import { useNavigate } from 'react-router-dom'

import { GenericCancelDialog } from '~/common/components'
import { links } from '~/AppRoutes'

type Props = {
  open: boolean
  onCancel: () => void
  href: string
}

export const CancelDialog = ({ open, onCancel, href }: Props) => {
  const navigate = useNavigate()
  return <GenericCancelDialog open={open} onAccept={() => navigate(href)} onReject={onCancel} />
}
